import React, { useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import Skeleton from "@mui/material/Skeleton";
import api from "../../api/api";

const SelectTemplate = ({ isModalOpen, setModalOpen, selectedTemplateref ,checkConsent}) => {
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedTemplate, setSelectedTemplate] = useState("");

  const fetchData = async () => {
    try {
      setLoading(true);
      const dataRes = await api.get("/v1/user_templates/get_populated_templates");
      const defaultRes = await api.get("/v1/user_templates/default_populated_templates");
      if (dataRes.status === 200 && defaultRes.status === 200) {
        setTemplates([...defaultRes.file_names, ...dataRes.file_names]);
      } else if (dataRes.status === 200) {
        setTemplates(dataRes.file_names);
      } else if (defaultRes.status === 200) {
        setTemplates(defaultRes.file_names);
      }
    } catch (error) {
      console.error("Error fetching templates:", error);
    } finally {
      setLoading(false);
    }
  };

  const formatSection = (section) => {
    return section
      ?.toLowerCase()
      ?.replace(/_/g, " ")
      ?.replace(/^./, (char) => char?.toUpperCase());
  };

  useEffect(() => {
    if (isModalOpen) {
      fetchData();
    }
  }, [isModalOpen]);

  const handleSave = () => {
    selectedTemplateref.current = selectedTemplate;
    checkConsent()
    setModalOpen(false);
  };

  const temp = Object.keys(templates?.reduce((acc, obj) => ({ ...acc, ...obj }), {}));

  if (!isModalOpen) {
    return null;
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="relative w-full max-w-md p-6 bg-white rounded-lg shadow-lg dark:bg-gray-800">
        {/* Close Button */}
        <button
          type="button"
          className="absolute top-3 right-3 text-gray-400 hover:text-gray-900 dark:hover:text-white"
          onClick={() => setModalOpen(false)}
        >
          <CloseIcon fontSize="large" />
          <span className="sr-only">Close modal</span>
        </button>

        {/* Modal Content */}
        <div className="flex flex-col gap-4">
          <label className="font-medium text-sm text-[#1c2a3a]">Select Template</label>
          {loading ? (
            <Skeleton variant="rectangular" height={40} className="w-full rounded-md" />
          ) : (
            <select
              className="w-full border border-gray-300 rounded-md p-2 text-sm focus:ring-2 focus:ring-[#1c2a3a]"
              onChange={(e) => setSelectedTemplate(e.target.value)}
            >
              <option value="">Choose Template</option>
              {temp?.map((template) => (
                <option key={template} value={template}>
                  {formatSection(template)}
                </option>
              ))}
            </select>
          )}

          {/* Save Button */}
          <div className="flex justify-end">
            <button
              className={`px-4 py-2 rounded-md text-white ${selectedTemplate ? "bg-[#1c2a3a] hover:bg-[#16202e]" : "bg-gray-400 cursor-not-allowed"}`}
              onClick={handleSave}
              disabled={!selectedTemplate}
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SelectTemplate;